'use strict';

Odigeo.defineWidget('accommodation_summary', Odigeo.Widget.extend({
    viewClass: require('../../modules/views/accommodation_summary'),

    toggleMapLink: function() {
        this.view.toggleMapLink.apply(this.view, arguments);
    },

    renderHtml: function(data) {
        this.model.set(data);
        this.view.renderHtml();
    },
}));
